import { type ComponentProps } from 'react';
import Drawer from 'components/Drawer';
import { TravelDetails } from './TravelDetails';

export function TravelDetailsDrawer({
  isOpen,
  onClose,
  flights,
}: {
  isOpen: boolean;
  onClose: () => void;
  flights: ComponentProps<typeof TravelDetails>['flights'];
}) {
  return (
    <Drawer
      header="Travel Details"
      isOpen={isOpen}
      onClose={onClose}
      ps={{
        base: 4,
        md: 8,
      }}
      pe={{
        base: 3,
        md: 6,
      }}
      pt={4}
      pb={8}
    >
      <TravelDetails
        header={`${flights.at(0)?.departureAirport.city} - ${flights.at(-1)?.arrivalAirport.city}`}
        i18n={{
          connectingFlightsCountText: 'Connecting flights',
          connectionSeparatorText: 'connected with',
        }}
        flights={flights}
      />
    </Drawer>
  );
}
